import { useEffect, useState } from "react";
// REDUX
import { useSelector } from "react-redux";
import { useGetLiftsLightQuery } from "../../redux/lifts/liftAPI";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";
// INTERFACE
import { LiftLightInterface } from "../../interfaces/Lift.interface";
import { RootState } from "../../app/store";

export default function useGetAllLiftsLight(overrideOrgId?: string) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [lifts, setLifts] = useState<LiftLightInterface[]>([]);
  const [token, setToken] = useState<string | null>(null);
  const [errorObject, setErrorObject] = useState<any>({});
  const [errorMessage, setErrorMessage] = useState<string>("Error");

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { globalOrganizationId } = useSelector((state: RootState) => state.home);
  const orgId = overrideOrgId || globalOrganizationId;

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const { data, isLoading, isError, isFetching, error } = useGetLiftsLightQuery(
    { token, orgId },
    { skip: !token, refetchOnMountOrArgChange: false },
  );

  // ************************************************ */
  // USE EFFECT ************************************* */
  useEffect(() => {
    GETJwtToken().then(setToken);
  }, []);

  useEffect(() => {
    if (data && data.data) {
      setLifts(data.data);
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      setErrorObject(error);
    }
  }, [error]);

  useEffect(() => {
    if (errorObject && errorObject.data && errorObject.data.message) {
      setErrorMessage(errorObject.data.message);
    }
  }, [errorObject]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return {
    liftsLight: lifts,
    isLoadingGetAllLiftsLight: isLoading || isFetching,
    errorMessageGetAllLiftsLight: errorMessage,
    isErrorGetAllLiftsLight: isError,
    totalRowsGetAllLiftsLight: data?.total ?? 0,
  };
}
